const trim = (u) => (u || '').replace(/\/+$/, '');

// Risk service (climate-indicators-models `risk/` module) — same base for the
// catalog (GET /risk) and the probability endpoint (GET /risk/probability).
// Dev goes through the vue.config.js proxy (/risk-api -> localhost:5000).
// Prod is models.agroclimate.org, matching _BASE_URL_PIXEL_MODEL in
// src/store/store.js (this codebase bakes prod URLs in rather than relying
// on env vars for them) — VUE_APP_RISK_API_URL remains a dev-time override.
export const RISK_API_BASE = trim(process.env.VUE_APP_RISK_API_URL) || 'https://models.agroclimate.org';

// 'fixtures' | 'live' — the backend has implemented GET /risk/probability
// (confirmed against localhost:5000 for freeze/heat_stress/arid), so this
// defaults to 'live' now. See src/store/modules/risk/riskApi.js.
export const RISK_PROBABILITY_SOURCE = process.env.VUE_APP_RISK_PROBABILITY_SOURCE || 'live';
export const RISK_PROBABILITY_BASE = trim(process.env.VUE_APP_RISK_PROBABILITY_URL) || RISK_API_BASE;
export const RISK_PROBABILITY_PATH = '/risk/probability';

// The catalog is a small static list — 15s is plenty.
export const RISK_TIMEOUT_MS = 15000;

// GET /risk/probability is a different animal: it recomputes a full multi-year
// climatology per request, and the ARID index routinely runs well past 15s.
// With the catalog's timeout applied to it, axios aborted healthy requests and
// the tab showed "The request took too long" (errors.js#COPY.timeout) over data
// that was on its way.
export const RISK_PROBABILITY_TIMEOUT_MS = Number(process.env.VUE_APP_RISK_PROBABILITY_TIMEOUT || 120000);

// How long the loading skeleton waits before saying it is still working. With a
// two-minute ceiling, a skeleton that never changes reads as a hung request.
export const RISK_LONG_WAIT_HINT_MS = 15000;

export const RISK_CACHE_LIMIT = 40;
export const RISK_FIXTURE_LATENCY_MS = Number(process.env.VUE_APP_RISK_FIXTURE_LATENCY || 450);
